<template>
  <div class="expert-extractReport-report" ref="print">
    <div style="text-align: center;margin-top: 10px" class="no-print">
      <el-button type="primary" v-if="showPrintButton" @click="print">打印</el-button>
    </div>
    <h2>项目评委名单</h2>
    <div>
      <table>
        <thead>
        <tr>
          <td style="width: 60px">序号</td>
          <td style="width: 100px">专家姓名</td>
          <td>工作单位</td>
          <td>申请专业</td>
          <td style="width: 100px">手机号</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in projectExpertList" v-bind:key="index">
          <td>{{index+1}}</td>
          <td>{{item.expertName}}</td>
          <td>{{item.expertEnterpriseName}}</td>
          <td>{{item.expertProfession}}</td>
          <td>{{item.expertPhone}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

    export default {
        name: "ExpertExtractReport",
        data() {
            return {
                projectId: "",
                projectExpertList: [],
                showPrintButton: true
            }
        },
        methods: {
            queryProjectExpert: function () {
                if (!this.projectId) {
                    return;
                }
                let params = {projectId: this.projectId, extractStatus: 1}//参加评审列表
                this.$api.projectExpert.getProjectExpertByCondition(params).then((res) => {
                    this.projectExpertList = res.data;
                })
            },
            /**
             * 打印
             */
            print: function () {
                this.showPrintButton = false;
                setTimeout(() => {
                    window.print();
                    setTimeout(() => {
                        this.showPrintButton = true;
                    }, 500)
                });
            }
        },
        mounted() {
            this.projectId = this.$route.query.projectId;
            $("body").css("height", "auto");
            $("#app").css("position", "relative");
            this.queryProjectExpert();
        }
    }
</script>

<style scoped lang="less">
  .expert-extractReport-report {
    padding: 30px 30px;
    text-align: left;
    max-width: 1050px;
    margin: 0 auto;
    letter-spacing: 2px;
    font-size: 20px;
    line-height: 40px;

    h2 {
      text-align: center;
      font-size: 38px;
    }

    table {
      border-collapse: collapse;
      width: 100%;

      thead {
        text-align: center;

        td {
          border: solid 1px #000000;
        }
      }

      tbody {
        text-align: center;

        td {
          border: solid 1px #000000;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Member/ExpertExtractReport.vue